import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "px-2 pt-2 pb-1 text-gray-500" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "px-2 pt-2 pb-1 text-gray-500" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "px-2 pt-2 pb-1 text-gray-500" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = {
  style: {"white-space":"pre-wrap","word-wrap":"break-word"},
  class: "px-2 pt-2 pb-1 text-gray-500"
}
const _hoisted_9 = { class: "flex items-center justify-end mt-10 mr-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.t('contact_faq.course')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.selectCourseCategory()), 1),
      _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.t('word.contents')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.selectCategory()), 1),
      _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.t('word.subject')), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.store.state.contact.contact.subject), 1),
      _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.t('word.body')), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.store.state.contact.contact.body), 1),
      _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        type: "button",
        class: "bg-gray-200 hover:bg-gray-300 text-gray-800 py-1.5 px-4 rounded disabled:opacity-75 mr-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.dispatch('contact/contactConfirmOff')))
      }, "キャンセル"),
      _createElementVNode("button", {
        disabled: _ctx.btnDisabled,
        type: "button",
        class: "bg-blue-500 hover:bg-blue-400 text-white py-1.5 px-4 rounded disabled:opacity-75",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onComplete()))
      }, [
        _createElementVNode("div", _hoisted_11, [
          (_ctx.btnDisabled)
            ? (_openBlock(), _createBlock(_component_base_svg_icon, {
                key: 0,
                class: "w-6 animate-spin mr-1 p-0.5",
                path: _ctx.mdiLoading
              }, null, 8, ["path"]))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "whitespace-nowrap" }, " 送信 ", -1))
        ])
      ], 8, _hoisted_10)
    ])
  ]))
}